import { cn } from '@/design-system/lib/cn';

export type SwitchProps = {
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  /** O rótulo visível fica ao lado; o nome acessível vem daqui. */
  'aria-label': string;
  disabled?: boolean;
  className?: string;
};

/** Interruptor de 36×22: índigo ligado, ardósia desligado. */
export function Switch({ checked, onCheckedChange, disabled, className, ...props }: SwitchProps) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={props['aria-label']}
      disabled={disabled}
      onClick={() => onCheckedChange(!checked)}
      className={cn(
        'h-5.5 w-9 shrink-0 rounded-pill p-0.5 transition-colors disabled:opacity-50',
        checked ? 'bg-primary' : 'bg-line-dashed',
        className
      )}
    >
      <span
        aria-hidden
        className={cn(
          'block size-4.5 rounded-pill bg-white shadow-raised transition-transform',
          checked ? 'translate-x-3.5' : 'translate-x-0'
        )}
      />
    </button>
  );
}
